import { Helmet } from "react-helmet";
import { useAppSelector } from "../redux/hooks";

// This component loads the IntentWave tracking script when useIdentityResolution is enabled
// in the brandAppConfig. It uses react-helmet to inject the script into the document head.

const IntentWaveTracker = () => {
  const useIdentityResolution = useAppSelector(
    ({ appConfig }) => appConfig?.brandAppConfig?.useIdentityResolution
  );

  if (!useIdentityResolution) {
    return null;
  }

  return (
    <>
      <Helmet>
        <script>
          {`window.IntentWave=window.IntentWave||{};window.IntentWave.track=window.IntentWave.track||function(){window.IntentWave.track.q=window.IntentWave.track.q||[];window.IntentWave.track.q.push(arguments)};(function(){var u='https://cdn.intentwave.com/';var d=document,g=d.createElement('script'),s=d.getElementsByTagName('script')[0];g.type='text/javascript';g.async=!0;g.defer=!0;g.src=u+'track.js';g.setAttribute('data-name','IntentWave');g.setAttribute('data-id', '6e757ade-c7ef-4e0b-b127-57881706c792');s.parentNode.insertBefore(g,s)})()`}
        </script>
      </Helmet>
    </>
  );
};

export default IntentWaveTracker;
